export class UploadConfig {
    /**
     * 发到后台的文件参数名
     */
    name?: string;
    /**
     * 文件上传路径
     */
    uplodUrl?: string;
    /**
     * 文件删除路径
     */
    deleteUrl?: string;
    /**
     * 删除的key,根据什么标识删除数据
     */
    deleteKey?: string;
    /**
     * 文件格式类型，默认为JPEG,PNG,JPG,忽略大小写
     */
    type?: string;
    /**
     * 最大上传数量
     */
    limit?: number;
    /**
     * 单张图片最大大小
     */
    size?: number;
    /**
     * 最多只能上传多少张图片
     */
    max?: number;
    /**
     * 是否允许批量上传
     */
    multiple?: boolean;
    /**
     * 上传按钮文字
     */
    uploadText?: string;
    /**
     * 文件数据
     */
    fileBaseUrl?: string;
    /**
     * 文件列表
     */
    fileList?: any[];
    /**
     * 是否显示上传按钮
     */
    showBtn?: boolean;

    fileListUrl?: string;
    /**
     * 文件类型:img或者file
     */
    fileType?: string;
    /**
     * 文件下载路径
     */
    donwnLoadUrl?: string;
    /**
     * 是否显示查看按钮
     */
    showPreviewIcon?: boolean;
    /**
     * 是否显示删除按钮
     */
    showRemoveIcon?: boolean;
    /**
     * 是否显示下载按钮
     */
    showDownloadIcon?: boolean;
    /**
     * 缓存旧数据
     */
    /**
     * 文件可选择类型
     */
    acceptType?: string;
    cacheData?: [];
    download?: (file: any) => void;
    constructor() {
        this.name = 'uploadFile';
        this.type = 'image/png,image/jpeg,image/jpg';
        this.size = 10 * 1024;
        this.multiple = false;
        this.uploadText = '';
        this.fileList = [];
        this.fileBaseUrl = '';
        this.showBtn = true;
        this.fileListUrl = '';
        this.max = 1;
        this.fileType = '';
        this.donwnLoadUrl = '';
        this.showPreviewIcon = true;
        this.showRemoveIcon = true;
        this.showDownloadIcon = false;
        this.cacheData = [];
        this.acceptType = '';
    }
}
